/**
 * Medications Workspace Feature Module
 *
 * Minimal feature configuration for API-only features (mirrors eprescriptions).
 * No Redux slice — all state is RTK Query.
 */

import type { FeatureModule } from '@store/features/types';

export const medicationsWorkspaceFeature: FeatureModule = {
  id: 'medications-workspace',
  name: 'Medications Workspace',
  dependencies: [],
  reducers: {},
  middleware: [],
};
